import { render, staticRenderFns } from "./MemberOrdersHistoryDetailDialog.vue?vue&type=template&id=2e1a4871&"
import script from "./MemberOrdersHistoryDetailDialog.vue?vue&type=script&lang=js&"
export * from "./MemberOrdersHistoryDetailDialog.vue?vue&type=script&lang=js&"
import style1 from "./MemberOrdersHistoryDetailDialog.vue?vue&type=style&index=1&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QTable,QInnerLoading,QTr,QTh,QTd,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QCardSection,QTable,QInnerLoading,QTr,QTh,QTd,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
